export default "__VITE_ASSET__BZtki1Dz__"